import { z } from "zod";
import { SupportedCurrencyCodesSchema } from "./currencies.js";
/** Public-subset user (returned by `GET /users/{userId}` to any authenticated caller). */
export const PublicUserSchema = z.strictObject({
    id: z.string().uuid(),
    displayName: z.string().min(1).max(64),
});
/** Self-view (returned by `GET /users/me`); includes private fields like email. */
export const UserSchema = z.strictObject({
    id: z.string().uuid(),
    displayName: z.string().min(1).max(64),
    email: z.string().email(),
    /**
     * The user's chosen display currency, used to convert cross-currency
     * balances into a single figure on summary screens. Optional because rows
     * created before the preference existed (and brand-new sign-ups) have none;
     * clients fall back to a timezone-derived default via
     * `resolvePreferredCurrency`.
     */
    preferredCurrency: SupportedCurrencyCodesSchema.optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
/** Body of `PATCH /users/me`. */
export const UpdateMeRequestSchema = z.strictObject({
    displayName: z.string().min(1).max(64).optional(),
});
/** Body of `PATCH /users/me/settings`. */
export const UpdateSettingsRequestSchema = z.strictObject({
    preferredCurrency: SupportedCurrencyCodesSchema.optional(),
});
